import { Component, inject, OnDestroy, OnInit, signal } from '@angular/core';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { EventMessage, EventType } from '@azure/msal-browser';
import { catchError, filter, map, of, throwError } from 'rxjs';
import { TENANT_ID } from './authorization/authorization-factories';
import { AuthorizationService } from './authorization/authorization.service';
import { ComponentBaseDirective } from './shared/components/component.base';
import { UserLoggedIn } from './shared/state/application.actions';
@Component({
    selector: 'app-root',
    templateUrl: './app.html',
    styleUrl: './app.scss',
    standalone: false,
})
export class App extends ComponentBaseDirective implements OnInit, OnDestroy {
    protected readonly title = signal('pressure-monitoring');

    public authorizationService: AuthorizationService = inject(AuthorizationService);
    private authService: MsalService = inject(MsalService);
    private msalBroadcastService: MsalBroadcastService = inject(MsalBroadcastService);
    private tenantId = inject(TENANT_ID);

    public get isIframe(): boolean {
        return window !== window.parent && !window.opener;
    }

    public get isTenantMissing() {
        return window.location.href.indexOf('not-found') !== -1 && this.tenantId == null;
    }

    public get isPageMissing() {
        return window.location.href.indexOf('not-found') !== -1 && this.tenantId != null;
    }

    public get isSettingPage() {
        return window.location.href.indexOf('settings') !== -1 && this.tenantId != null;
    }

    public displayPage$ = this.authorizationService.hasPermissions$.pipe(map((hasPermissions) => hasPermissions || this.isTenantMissing));

    public async ngOnInit() {
        this.addLoader('master', UserLoggedIn);

        if (!this.isTenantMissing) {
            this.loaderService.startLoader('master');
        }

        if (this.isIframe) {
            return;
        }

        this.authorizationService.subscribeLoginInProgress();

        this.subscribeMSALSubject();
    }

    public viewAssets() {
        const origin = window.location.origin;
        const isLocal = window.location.hostname === 'localhost';

        let redirectUrl = '';
        if (isLocal) {
            redirectUrl = origin.replace('5005', '5001');
        } else {
            redirectUrl = origin.replace('pressure', 'iot');
        }

        window.open(`${redirectUrl}/${this.tenantId}`, '_blank');
    }

    private subscribeMSALSubject() {
        this.subscription.add(
            this.authService
                .handleRedirectObservable()
                .pipe(
                    catchError((error: Error) => {
                        if (error.message.includes('Guard - error while logging in, unable to activate')) {
                            this.authorizationService.handleAcquireToken();
                            return of();
                        }

                        return throwError(() => error);
                    })
                )
                .subscribe()
        );

        this.subscription.add(
            this.msalBroadcastService.msalSubject$
                .pipe(filter((eventMessage: EventMessage) => eventMessage.eventType === EventType.LOGIN_SUCCESS || eventMessage.eventType === EventType.ACQUIRE_TOKEN_SUCCESS || eventMessage.eventType === EventType.SSO_SILENT_SUCCESS))
                .subscribe((eventMessage: EventMessage) => {
                    this.authorizationService.handleRedirectAfterLogin(eventMessage);
                })
        );

        this.subscription.add(
            this.msalBroadcastService.msalSubject$.pipe(filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_FAILURE || msg.eventType === EventType.ACQUIRE_TOKEN_FAILURE)).subscribe((result: EventMessage) => {
                this.authorizationService.handleRedirectPasswordReset(result);
            })
        );
    }
}
